export default (I18n) => (value, opts = null) => {
  if (!value) return ''
  value = value.toString()
  return I18n.t(value, opts)
}
